/** Build IAM service URLs from the shared API base URL. */
export const getIamServiceUrl = (path: string): string => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL?.trim().replace(/\/+$/, '');
  if (!baseUrl) throw new Error('VITE_API_BASE_URL is not configured');
  return `${baseUrl}/${path.replace(/^\/+/, '')}`;
};
